import { makeStyles } from "@material-ui/core";
import { useQuery } from "@redux-requests/react";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { BaseLayout, Header } from "../components";
import EPostersGrid from "../components/EPostersGrid";
import { getEPosters } from "../ducks/actions";
import * as types from "../ducks/types";
import { EditEposterDialog } from "../features/eposters";
import useUserMe from "../hooks/useUserMe";
import { ReactComponent as EposterSvg } from "../assets/icons/eposters.svg";

const useStyles = makeStyles(theme => ({
  root: {
    "& > *": {
      marginBottom: theme.spacing(3)
    }
  },
  filter: {
    marginLeft: theme.spacing(1),
    flexGrow: 0.2
  }
}));

const MyPostersPage = () => {
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();
  const history = useHistory();

  const { user } = useUserMe();

  useEffect(() => {
    if (user.profile?.id)
      dispatch(getEPosters({ profileId: user.profile?.id, sort: ["title asc"] }));
  }, [dispatch, user.profile?.id]);

  const {
    data: { data: myPosters },
    loading: myPostersLoading
  } = useQuery({ type: types.GET_EPOSTERS, defaultData: { data: [] } });

  const [eposterId, setEposterId] = useState(null);

  const onEditEposterDialogClose = () => {
    setEposterId(null);
  };

  const onManageQuestions = id => {
    history.push(`/e-posters/${id}`);
  };

  const onEdit = id => {
    setEposterId(id);
  };

  const actions = id => [
    {
      label: intl.formatMessage({
        id: "Pages.MyPostersPage.MenageQuestions",
        defaultMessage: "Manage Questions"
      }),
      action: () => onManageQuestions(id)
    },
    {
      label: intl.formatMessage({
        id: "Pages.MyPostersPage.Edit",
        defaultMessage: "Edit"
      }),
      action: () => onEdit(id)
    }
  ];

  return (
    <BaseLayout className={classes.root}>
      <Header
        icon={EposterSvg}
        title={intl.formatMessage({
          id: "Pages.MyPostersPage.MyPosters",
          defaultMessage: "My Posters"
        })}
        helper={intl.formatMessage({
          id: "Pages.MyPostersPage.MyPostersHelper",
          defaultMessage:
            "Welcome to your personal area! Here you can upload your e-poster and you will be able to reply to the comments or questions regarding your e-poster that the congress attendees might be asking you. If you need information or help please check the Help Desk Session."
        })}
      />
      <EPostersGrid
        loading={myPostersLoading}
        ePosters={myPosters}
        isEditable
        actions={actions}
        truncateWords
      />
      {eposterId && <EditEposterDialog id={eposterId} onClose={onEditEposterDialogClose} />}
    </BaseLayout>
  );
};

export default MyPostersPage;
